/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    background: { type: 'variant', values: [ true ] },
    color: {
      description: 'Use colour to change the colour',
      type: 'variant',
      values: [
        'brand',   'subtle',
        'offer',   'success',
        'danger',  'warning',
        'inverse'
      ]
    },
    padding: {
      type: 'variant',
      values: [ 'micro', 'small', 'medium', 'large', 'extraLarge' ]
    },
    size: {
      description: 'Use size to change the dimension of the icon',
      type: 'variant',
      values: [ 'micro', 'small', 'large', 'extraLarge' ]
    }
  },
  rules: [
    { if: { padding: 'micro' }, tokens: { padding: 4, width: 4 } },
    { if: { padding: 'small' }, tokens: { padding: 4, width: 8 } },
    { if: { padding: 'medium' }, tokens: { padding: 4, width: 16 } },
    { if: { padding: 'large' }, tokens: { padding: 4, width: 24 } },
    {
      if: { padding: 'extraLarge' },
      tokens: { padding: 4, width: 32 }
    },
    {
      if: { background: true, padding: 'micro' },
      tokens: {
        backgroundColor: '#f5f5f7',
        borderRadius: 45,
        padding: 4,
        width: 4
      }
    },
    {
      if: { background: true, padding: 'small' },
      tokens: {
        backgroundColor: '#f5f5f7',
        borderRadius: 45,
        padding: 4,
        width: 8
      }
    },
    {
      if: { background: true, padding: 'medium' },
      tokens: {
        backgroundColor: '#f5f5f7',
        borderRadius: 45,
        padding: 4,
        width: 16
      }
    },
    {
      if: { background: true, padding: 'large' },
      tokens: {
        backgroundColor: '#f5f5f7',
        borderRadius: 45,
        padding: 4,
        width: 24
      }
    },
    {
      if: { background: true, padding: 'extraLarge' },
      tokens: {
        backgroundColor: '#f5f5f7',
        borderRadius: 45,
        padding: 4,
        width: 32
      }
    },
    { if: { size: 'micro' }, tokens: { size: 16 } },
    { if: { size: 'small' }, tokens: { size: 20 } },
    { if: { size: 'large' }, tokens: { size: 32 } },
    { if: { size: 'extraLarge' }, tokens: { size: 48 } },
    { if: { color: 'brand' }, tokens: { color: '#394056' } },
    { if: { color: 'subtle' }, tokens: { color: '#6a7080' } },
    { if: { color: 'offer' }, tokens: { color: '#f39d80' } },
    { if: { color: 'success' }, tokens: { color: '#2b826e' } },
    { if: { color: 'danger' }, tokens: { color: '#bf1722' } },
    { if: { color: 'warning' }, tokens: { color: '#394056' } },
    { if: { color: 'inverse' }, tokens: { color: '#ffffff' } }
  ],
  tokens: {
    backgroundColor: 'transparent',
    borderRadius: 0,
    color: '#394056',
    padding: 0,
    paddingTop: 0,
    scale: 1,
    size: 24,
    translateX: 0,
    translateY: 0,
    width: 0
  }
}
export default theme
